import React, { useState } from "react";
import Header from "./Header";
import Leftmenu from "./Leftmenu";
import Footer from "./Footer";
import { SidebarProvider, useSidebar } from "./SidebarContext";

const LayoutHOC = (WrappedComponent) => {
  // Return a proper functional component
  const Layout = (props) => {
    const [refreshKeyImage, setRefreshKeyImage] = useState(0); // State for triggering re-renders

    // Function to trigger a refresh
    const handleRefresh = () => {
      setRefreshKeyImage((prevKey) => prevKey + 1);
    };

    // const sidebarContext = useSidebar();
    // const showSideBar = sidebarContext?.showSideBar

    return (
      <div className="flex w-full h-full overflow-y-auto">
        <SidebarProvider>
          {true && <Leftmenu refreshKeyImage={refreshKeyImage} />}
          <div className="flex flex-col grow min-w-0">
            <Header />
            <main id="maincontent" className="grow min-h-0">
              <WrappedComponent {...props} onRefreshSidebar={handleRefresh} />
            </main>
          </div>
        </SidebarProvider>
      </div>
    );
  };

  return Layout;
};

export default LayoutHOC;
